<template>
  <v-app v-cloak>
    <v-fade-transition>
      <router-view />
    </v-fade-transition>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'BCube CMS',
  },
  computed: {
    activeFullscreenDialog() {
      return this.$store.state.app.activeFullscreenDialogs.length > 0;
    },
  },
  watch: {
    activeFullscreenDialog: {
      handler(val) {
        document.querySelector('html')
          .classList
          .toggle('overflow-hidden', val);
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener('unload', () => {
      this.$store.dispatch('room/LEAVE_ALL_ROOMS');
    });
  },
};
</script>
